// GetNiveles.jsx
import { Box, FormControl, Grid, MenuItem, Select, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { get_niveles } from "../services/api";
import { UseSetLenguajePorPais } from "../hooks/UseSetLenguajePorPais";
import { useTranslation } from "react-i18next";
import { useAuthContext } from "../hooks/Auth";

export default function GetNiveles({ onNivelChange, selectedNivel }) {
    const [data, setData] = useState([]);
    const [selectedNivelId, setSelectedNivelId] = useState(""); // Estado para el ID seleccionado
    const { t } = useTranslation();
    const { user } = useAuthContext();

    // Hook para lenguaje según país
    UseSetLenguajePorPais();

    useEffect(() => {
        async function ObtenerDatosDeAPI() {
            if (!user?.pais) {
                console.error("No se encontró el país en el contexto del usuario");
                return;
            }
            try {
                const { data, status } = await get_niveles(user.pais);
                if (status === 200) {
                    const nivelesArray = data.body.map(({ id_nivel, name }) => ({
                        id: id_nivel,
                        nombre: name,
                    }));
                    setData(nivelesArray);
                } else {
                    console.error("La solicitud a la API no fue exitosa.");
                }
            } catch (error) {
                console.error("Se produjo un error al realizar la solicitud a la API:", error);
            }
        }

        ObtenerDatosDeAPI();
    }, [user?.pais]);

    useEffect(() => {
        // Cuando `selectedNivel` (id) cambia, actualizar el estado interno directamente
        if (selectedNivel) {
            setSelectedNivelId(selectedNivel);
        }
    }, [selectedNivel, data]);

    const handleNivelChange = (event) => {
        const selectedNivelId = event.target.value;
        const selectedNivelObj = data.find((nivel) => nivel.id === selectedNivelId);

        if (selectedNivelObj) {
            setSelectedNivelId(selectedNivelId); // Actualiza el estado interno
            console.log("Nivel seleccionado:", selectedNivelObj.nombre, selectedNivelObj.id);
            // Se envían ambos parámetros: nombre e id
            onNivelChange(selectedNivelObj.nombre, selectedNivelObj.id);
        }
    };

    useEffect(() => {
        setSelectedNivelId(selectedNivel || ""); // <--- actualiza siempre, incluso si está vacío
    }, [selectedNivel]);

    return (
        <Grid item xs={12}>
            <Box>
                <Typography sx={{ fontFamily: "montserrat", fontSize: "1.25rem", fontWeight: "bold", color: "#336B87" }}>
                    {t("nivel")}
                </Typography>
                <FormControl fullWidth>
                    <Select
                        labelId="select-nivel"
                        id="select-nivel"
                        variant="outlined"
                        displayEmpty
                        value={selectedNivelId}
                        onChange={handleNivelChange}
                        sx={{
                            fontFamily: "montserrat",
                            fontSize: "14px",
                            borderRadius: 2,
                            "& .MuiOutlinedInput-root": { borderRadius: 2 },
                            "& fieldset": { borderColor: "#BDBDBD" },
                            "&:hover fieldset": { borderColor: "#9E9E9E" },
                            "&.Mui-focused fieldset": { borderColor: "#005559" },
                            "& .MuiSelect-select": {
                                color: selectedNivel ? "#005559" : "#B3D1D1",
                            },
                        }}
                    >
                        <option hidden value="">
                            Selecciona hasta 1 opción máximo.
                        </option>
                        {data.map((nivel) => (
                            <MenuItem key={nivel.id} value={nivel.id} sx={{ color: "#336B87" }}>
                                <Typography sx={{ fontFamily: "montserrat", fontSize: "0.8rem", color: "#336B87" }}>
                                    {nivel.nombre}
                                </Typography>
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>
        </Grid>
    );
}
